/**!
 * Created by Leonardo Cheslacki on 25/08/2023.
 *
 * MIT License
 *
 * Copyright (c) 2023 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import HelpersController from './HelpersController';

let _this = {};

/**
 *
 */
class HelpersPin extends HelpersController {

    /**
     *
     * @param props
     */
    constructor(props) {
        super(props);
        this.props = props;
        _this = this;
    };

    /**
     *
     * @param occ_text
     * @param string
     * @param color
     * @param font
     * @param size
     * @param weight
     */
    setText = (occ_text, string, color, font, size, weight) => {
        if (!this.isEmpty(string) && this.verifyField(occ_text, 'text')) {
            occ_text.text = this.toCapitalize(string);
        }
        if (this.isTintColor(color) && this.verifyField(occ_text, 'color')) {
            occ_text.color = this.tintToHex(color);
        }
        if (!this.isEmpty(font) && this.isInteger(size) && this.verifyField(occ_text, 'font')) {
            occ_text.font = `${(!this.isEmpty(weight) ? `${weight.toLowerCase()} ` : ``)}${size}px '${font}'`;
        }
    };

    /**
     *
     * @param occ_pin_number
     * @param number
     * @param x
     * @param y
     * @param color
     * @param font
     * @param size
     * @param weight
     */
    setNumber = (occ_pin_number, number, x, y, color= null, font= null, size= null, weight = null) => {
        if (this.isIntegerOrFloat(number) && this.verifyField(occ_pin_number, 'text')) {
            occ_pin_number.text = this.padWithLeadingZeros(number, 2);
        }
        if (this.isTintColor(color) && this.verifyField(occ_pin_number, 'color')) {
            occ_pin_number.color = this.tintToHex(color);
        }
        if (!this.isEmpty(font) && this.isInteger(size) && this.verifyField(occ_pin_number, 'font')) {
            occ_pin_number.font = `${(!this.isEmpty(weight) ? `${weight.toLowerCase()} ` : ``)}${size}px '${font}'`;
        }
        x = this.toIntegerOrFloat(x);
        if (this.isIntegerOrFloat(x) && this.verifyField(occ_pin_number, 'x')) {
            occ_pin_number.x = x;
        }
        y = this.toIntegerOrFloat(y);
        if (this.isIntegerOrFloat(y) && this.verifyField(occ_pin_number, 'y')) {
            occ_pin_number.y = y;
        }
    };

    /**
     *
     * @param occ_color
     * @param color
     */
    setColor = (occ_color, color) => {
        let children = this.verifyField(occ_color, 'children', false, []);
        if (this.isTintColor(color) && this.isArrayIf(children)) {
            let child = children[0];
            if (this.verifyField(child, 'graphics._fill.style')) {
                child.graphics._fill.style = this.tintToHex(color);
            } else if (this.verifyField(child, 'graphics._stroke.style')) {
                child.graphics._stroke.style = this.tintToHex(color);
            }
        }
    };

    /**
     *
     * @param object
     * @param x
     * @param y
     */
    setCoordinate = (object, x, y) => {
        x = this.toIntegerOrFloat(x);
        y = this.toIntegerOrFloat(y);
        this.isIntegerOrFloat(x) && (object.x = x);
        this.isIntegerOrFloat(y) && (object.y = y);
    };

    /**
     *
     * @param occ_pin_animate
     * @param visible
     */
    setAnimate = (occ_pin_animate, visible) => {
        occ_pin_animate.visible = visible;
    };

    /**
     *
     * @param object
     * @param enabled
     * @param cursor
     * @param uri
     */
    setAction = (object, enabled, cursor, uri) => {
        object.mouseEnabled = enabled;
        !this.isEmpty(cursor) && (object.cursor = cursor);
        !this.isEmpty(uri) && (object.uri = uri);
    };
}

/**
 *
 * @type {{}}
 */
const propTypes = {};

/**
 *
 * @type {{default: {}}}
 */
const config = {
    default: {}
};

export default (props) => {
    const defaultProps = {...config.default, ...props};
    PropTypes.checkPropTypes(propTypes, defaultProps, 'prop', 'HelpersPin');
    return (new HelpersPin(defaultProps));
};